/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Table, Skeleton, Empty } from "antd";
import { onShowSizeChange, itemRender } from "../../Pagination";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { getQuestionnariesHistory } from "../../../services/patient";
const QuestionnarieList = ({ insuredMember }) => {
  const [loading, setLoading] = useState(false);
  //Patients list
  const [datasource, setDatasource] = useState([]);
  const [originalDatasource, setOriginalDatasource] = useState([]);
  //Functions
  const columns = [
    {
      title: "Nombre",
      dataIndex: "Name",
      sorter: (a, b) => a.name.length - b.name.length,
      render: (text, record) => (
        <>
          <h2 className="profile-image">
            <Link to="#" className="avatar avatar-sm me-2">
              <FeatherIcon icon="check-square" />
            </Link>
            <Link to="#">{record.name}</Link>
          </h2>
        </>
      ),
    },
    //
    {
      title: "Resultado",
      dataIndex: "result",
      sorter: (a, b) => a.result.length - b.result.length,
    },
    {
      title: "Fecha",
      dataIndex: "date",
      sorter: (a, b) => a.date.length - b.date.length,
      render: (text, record) => (
        <>
          <Link to="#">{record.date}</Link>
        </>
      ),
    },
    {
      title: "Creado por",
      dataIndex: "createdBy",
      sorter: (a, b) => a.createdBy.length - b.createdBy.length,
      render: (text, record) => (
        <>
          <FeatherIcon icon="user" />
          &nbsp;
          {record.createdBy}
        </>
      ),
    },
  ];
  // Get Patients
  const getQuestionaries = async () => {
    setDatasource([]);
    setLoading(true);
    const response = await getQuestionnariesHistory(insuredMember);
    setDatasource(response);
    setOriginalDatasource(response);
    setLoading(false);
  };
  //Filter datasource by input value
  const filterDatasource = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue === "") {
      setDatasource(originalDatasource);
    } else {
      const filteredData = originalDatasource.filter((item) => {
        return Object.keys(item).some((key) =>
          item[key].toString().toLowerCase().includes(lowercasedValue)
        );
      });
      setDatasource(filteredData);
    }
  };
  // UseEffect for fetch data
  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      setLoading(true);
      getQuestionaries();
      setLoading(false);
    }
    return () => {
      mounted = false;
    };
  }, [false]);
  return (
    <>
      {/* Search Filters */}
      <div className="row">
        <div className="col-sm-12">
          <div className="card card-table show-entire">
            <div className="card-body">
              <div className="staff-search-table">
                {/* Basic Filters */}
                <div className="row">
                  <div className="col-12 col-md-5 col-xl-5">
                    <div className="table-search-blk">
                      <div className="form-group local-forms search-icon">
                        <form>
                          <input
                            type="text"
                            className={[" form-control"]}
                            placeholder="Búscar"
                            onChange={(e) => filterDatasource(e.target.value)}
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End Basic Filters */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Search Filters */}
      <div className="card card-table">
        <div className="card-body">
          <div
            className="table-responsive doctor-list"
            style={{ margin: "10px" }}
          >
            {
              <Table
                pagination={{
                  total: datasource.length,
                  showTotal: (total, range) =>
                    `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                  onShowSizeChange: onShowSizeChange,
                  itemRender: itemRender,
                }}
                columns={columns}
                dataSource={datasource}
                rowKey={(record) => record.id}
                locale={{
                  emptyText: loading ? (
                    <Skeleton active />
                  ) : (
                    <Empty description="No hay datos para mostrar" />
                  ),
                }}
              />
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionnarieList;
